import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import CreateAssessmentOptions from './components/CreateAssessmentOptions';
import PublicAssessments from './components/PublicAssessments';
import Footer from './components/Footer';
import VideoModal from './components/VideoModal';
import PWAInstallPrompt from './components/PWAInstallPrompt';
export function App() {
  const [showVideoTour, setShowVideoTour] = useState(false);
  const videoUrl = '';
  const handleStartVideoTour = () => {
    setShowVideoTour(true);
  };
  return <div className="flex flex-col min-h-screen bg-background" data-id="element-0">
      <Header onStartVideoTour={videoUrl ? handleStartVideoTour : undefined} data-id="element-1" />
      <PWAInstallPrompt data-id="element-2" />
      <div className="flex flex-1 overflow-hidden" data-id="element-3">
        <div className="hidden md:block" data-id="element-4">
          <Sidebar data-id="element-5" />
        </div>
        <div className="flex-1 flex flex-col min-w-0 w-full overflow-y-auto" data-id="element-6">
          <main className="flex-1" data-id="element-7">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-12 py-6 sm:py-8 md:py-12" data-id="element-8">
              <CreateAssessmentOptions data-id="element-9" />
              <PublicAssessments data-id="element-10" />
            </div>
          </main>
          <Footer data-id="element-11" />
        </div>
      </div>
      {showVideoTour && videoUrl && <VideoModal videoUrl={videoUrl} onClose={() => setShowVideoTour(false)} data-id="element-12" />}
    </div>;
}